import React from "react";
import translit from "translit-passport";
import { LANG } from "~/constans/commom";
import s from "./Cells.less";

interface ViolationTypeCellProps {
  violationType?: string | null;
  lang?: string | null;
}

export const ViolationTypeCell: React.FC<ViolationTypeCellProps> = ({
  violationType,
  lang,
}) => {
  if (!violationType) return <span>-</span>;

  const currentLang = lang || localStorage.getItem("language");
  const isEng = currentLang === LANG.en;

  return (
    <div className={s.violationType}>
      {isEng ? translit.cyrillicToLatin(violationType) : violationType}
    </div>
  );
};
